import { MetricsChart } from 'components/MetricsChart';
import { DonutChartConfig } from 'components/chart/data/DonutChartConfig';
import { ChartDataArray } from 'components/chart/data/ChartDataArray';
import { ChartDataType } from 'components/chart/data/ChartDataType';
import { ChartData } from 'components/chart/data/ChartData';
import { ChartDataComparisonType } from 'components/chart/data/ChartDataComparisonType';
import { useModelService } from 'services/model/model.service';
import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { DonutChartRenderer } from 'components/chart/renderer/DonutChartRenderer';
import { formatDateRangeLabel } from 'pages/insights-pro/country-tab/util';
import { TileContent } from 'components/Layout/PageContainer';
import { getArrayWithIsOthers } from 'pages/insights-pro/common/graphs/getArrayWithIsOthers';
import { useAppStore } from 'hooks/state/useAppStore';
import { CategoryInfo } from '../model';

interface CategorySharesProps {
  categories: CategoryInfo[];
  isComparisonActive: boolean;
}

export function CategoryShares({ categories, isComparisonActive }: CategorySharesProps) {
  const { getMeasureByMetric } = useModelService();

  const intl = useIntl();

  const { dateRange } = useAppStore();

  const ordGmvVal = getMeasureByMetric('ordGmvVal', 'OD');

  const donutData = useMemo(
    () => getArrayWithIsOthers(categories, [ordGmvVal.code], intl, c => c),
    [categories, isComparisonActive]
  );

  const createDonutChartConfig = () => {
    const donutChartConfig = new DonutChartConfig();
    donutChartConfig.value = {
      code: ordGmvVal.code,
      label: ordGmvVal.metric.name,
      unit: ordGmvVal.metric.unit,
    };
    donutChartConfig.legendConfig = {
      hide: false,
    };
    donutChartConfig.svgClassName = 'overflow-visible';

    donutChartConfig.data = [
      new ChartDataArray(
        ChartDataType.primary,

        formatDateRangeLabel(dateRange.range, intl),
        donutData.map(category => {
          const chartData = new ChartData(category.name, ordGmvVal.getValue(category.entry.values));
          chartData.color = category.color;
          return chartData;
        })
      ),
    ];
    if (isComparisonActive) {
      donutChartConfig.data.push(
        new ChartDataArray(
          ChartDataType.primary,
          formatDateRangeLabel(dateRange.comparison, intl),
          donutData.map(d => new ChartData(d.name, ordGmvVal.getValue(d.entry.compareValues))),
          ChartDataComparisonType.comparison
        )
      );
    }

    return donutChartConfig;
  };

  const categoryShareRenderer = new DonutChartRenderer(createDonutChartConfig());

  return (
    <TileContent className="flex h-full justify-between items-center">
      <MetricsChart renderer={categoryShareRenderer} height="h-[300px]" />
    </TileContent>
  );
}
